import React from "react";

import ReactMarkdown from "react-markdown";
import { Accordion, Container } from "react-bootstrap";

import { TabContentSection } from "../../../../containers/singleSim/styledSimContainer";
import { StyledAccordionItem } from "../../../../style/base/styledPublicPages";

const SimSourcesComponent = ({ simInfoData: { singleSimDetail: data } }) => {
  return (
    <TabContentSection className="my-4">
      <Container className="py-5">
        <Accordion defaultActiveKey="0">
          <StyledAccordionItem className="bg-transparent px-3" $isSim>
            <Accordion.Header>منابع</Accordion.Header>
            <Accordion.Body>
              <ReactMarkdown className="text-break px-3">
                {data.source}
              </ReactMarkdown>
            </Accordion.Body>
          </StyledAccordionItem>
        </Accordion>
      </Container>
    </TabContentSection>
  );
};

export default SimSourcesComponent;
